<div class="backdrop" (click)="closeModal()">
	<div class="modal-actividad">
		<!-- <div class="button-close ion-activatable ripple-parent" (click)="cerrarModal()">
			<ion-ripple-effect></ion-ripple-effect>
			<ion-icon name="close" class="noHover"></ion-icon>
		</div> -->

		<div class="content-reconocimiento-modal p-4">
			<div class="title-content pb-4" (click)="controlPropagation($event)" >
				<span class="text-sm font-semibold text-gray-900">{{title}}</span>
			</div>
			<div class="body-content pt-3 flex flex-col items-center">
        <ng-container *ngIf="codedList else simpleList">
          <div  *ngFor="let option of optionsList" (click)="onSelectedOption(option.code)" class="w-full flex justify-between items-center p-2 text-sm font-normal text-center hover:bg-primary_ultra_light_variant cursor-pointer">
            <span >{{ option.name }}</span>
            <!-- <ion-icon *ngIf="checkedOption === option.code" name="checkmark-outline" class="text-gray-900 text-lg"></ion-icon> -->
          </div>
        </ng-container>
        
        <ng-template #simpleList>
          <div  *ngFor="let option of optionsList" (click)="onSelectedOption(option)" class="w-full flex justify-between items-center p-2 text-sm font-normal text-center hover:bg-primary_ultra_light_variant cursor-pointer">
            <span >{{ option }}</span>
            <!-- <ion-icon *ngIf="checkedOption === option.code" name="checkmark-outline" class="text-gray-900 text-lg"></ion-icon> -->
          </div>
        </ng-template>
			</div>
		</div>
	</div>
</div>
